import { render, staticRenderFns } from "./icon-notification.vue?vue&type=template&id=3d01b0b7&scoped=true&"
import script from "./icon-notification.vue?vue&type=script&lang=ts&"
export * from "./icon-notification.vue?vue&type=script&lang=ts&"
import style0 from "./icon-notification.vue?vue&type=style&index=0&id=3d01b0b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01b0b7",
  null
  
)

export default component.exports